export default __webpack_public_path__ + "maps-examples-offline-pack-thumbnail-960-b4e3a9a7577cfbd64c275192444dd9f5.png";